import React from "react";

function OurVision() {
  return (
    <div>
      <div class="container mx-auto flex px-5 pt-24 items-center justify-center flex-col">
        <div class="text-center lg:w-2/3 w-full">
          <p class="mb-8 leading-relaxed sm:leading-relaxed sm:text-3xl text-2xl font-semibold">
            Mentoring can help you turn{" "}
            <span className="font-semibold bg-gradient-to-r from-blue-500 to-blue-900 text-transparent bg-clip-text">
              your passion
            </span>{" "}
            into conversations, friendships and network globally.
          </p>
        </div>
      </div>
    </div>
  );
}

export default OurVision;
